import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { toast } from "sonner";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { getPortfolioIdReportingV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const usePortfolioIdReportingQuery = (id?: number) => {
	const { t } = useResource();

	const result = useQuery({
		queryKey: PortfolioKeys.reporting(id ?? null),
		queryFn: processResponse(() => getPortfolioIdReportingV2(id!)),
		enabled: Boolean(id),
	});

	useEffect(() => {
		if (result.data?.failed) {
			toast.error(t(Resources.Portfolio.Chart.ReportingDataUnavailable));
		}
	}, [result.data?.failed, t]);

	return result;
};
